<template>
<span>
  <el-dialog
      width="70%"
      :visible.sync="show_test_editor">
            <el-select filterable style="padding-left:10px;" v-model="tentative_filter.field_name" placeholder="Select">
                <el-option
                    v-for="field in metadata"
                    :key="field.id"
                    :label="field.display_name"
                    :value="field.display_name">
                </el-option>
            </el-select>
            <el-button @click="show_operator_panel" style="">{{tentative_filter.operation}}</el-button>
    <span v-if="show_filter_value">
            <el-select allow-create style="" filterable v-model="tentative_filter.field_value" placeholder="Select">
                <el-option
                    v-for="possible in possible_values"
                    :key="possible.value"
                    :label="possible.value + ' (' + possible.count + ')'"
                    :value="possible.value"
                ></el-option>
            </el-select>
            <el-select style="width:70px;" v-model="tentative_filter.value_type" >
              <el-option
                  v-for="type in possible_types"
                  :key="type.key"
                  :label="type.value"
                  :value="type.key"
              ></el-option>
            </el-select>
      </span>
            <el-button @click="use_now">Use now</el-button>
            <el-button @click="delete_test" v-if="mode==='modify'" icon="el-icon-delete"></el-button>
    <div v-if="show_operator_options" style="margin-top:20px;">
          <el-button v-for="operator in operators_to_show" @click="operator_select(operator)" @mouseover.native="set_operator_text(operator)">{{operator.short}}</el-button>
    </div>
    <div v-if="operator_text" style="background-color:lightgray;margin-top:20px;padding:5px;">
      <div><strong>{{operator_text}}</strong></div>
      <div v-if="operator_instructions">Instructions: {{operator_instructions}}</div>
    </div>

  </el-dialog>
  <span style="margin-left: 10px;">
    <el-tooltip v-if="shared"  placement="top">
      <div slot="content">This is a SHARED filter.<br /> If you change the filter settings <br /> and then save this chart, you are saving it for <br /> all charts, rules, and crawls that use the filter.</div>
      <i style="color:red" class="el-icon-warning-outline"></i>
    </el-tooltip>
    <span v-if="shared">
      <span style="color:red">Filter {{shared_name}}{{modified_asterisk}}:</span>
    </span>
    <span v-else>
      Filters:
    </span>
      <span v-for="test in all_filter_tests">
        <el-button @click="editExistingTest(test)" type="text">
        {{test.field_name}} {{test.operation}} {{test.field_value}}
        </el-button>
        |
      </span>
     <el-button @click="addNewTest" icon="el-icon-plus" size="mini" type="text"></el-button>
  </span>
</span>
</template>

<script>

export default {
  name: "Filters",
  props: ['extent_id','filter_id','metadata','metadata_extended','temp_filter_tests_to_add','reset'],
  data() {
    return {
      show_filter_value: true,
      operator_text: "",
      operator_instructions: "",
      tentative_filter: {
        field_name: null,
        operation: "=",
        field_value: null,
        value_type: 'text',
      },
      tentative_before_values: {},
      show_operator_options: false,
      operators: ['='],
      all_saved_filters_for_extent: [],
      all_filter_tests: [],
      show_test_editor: false,
      mode: 'new',
      modified_asterisk: '',
      shared: false,
      shared_name: '',
      possible_types: [
        {key: 'text', value: 'Az'},
        {key: 'date', value: '📅'},
        {key: 'number', value:'09'}
      ],
    }
  },
  computed: {
      operators_to_show: function() {
        return this.operators.filter(o => {
          if (!o.db) return false;
          return ! (
              o.short === 'between' ||
                  o.short === 'in_year' ||
                  o.short === 'in_year_month'
          )
        })
      },
      saved_filter: function() {
          if (
              this.all_saved_filters_for_extent &&
              this.all_saved_filters_for_extent.length > 0
          ) {
            return this.all_saved_filters_for_extent.find(f => {
              return f.id === this.filter_id
            })
          } else {
            return {}
          }
      },
      possible_values: function () {
          if (this.metadata_extended && this.metadata_extended.columns) {
            let column_matches = this.metadata_extended.columns.filter(a => {
              return a.display_name === this.tentative_filter.field_name
            })
            if (column_matches.length>=1) {
              return column_matches[0].popular_values
            } else {
              return null
            }
          } else {
            return null
          }
      },
      existing_filter_text: function() {
        if (this.all_filter_tests) {
          let text = ''
          this.all_filter_tests.forEach(f => {
            text = text + f.field_name + ' ' + f.operation + ' ' + f.field_value + '. '
          })
          return text
        } else {
          return '(none)'
        }
      },
  },
  watch: {
    reset: function() {
      this.all_filter_tests = []
      this.$emit('updateAllFilterTests', {
        all_filter_tests: this.all_filter_tests,
        changed: false,
      })
      this.modified_asterisk = ''
    },
    extent_id: function() {
      axios.get('/api/filters/pulldowns/' + this.extent_id)
          .then(response => {
            this.operators = response.data.operators
          })
          .catch(error => {
            console.log('oops asset filter pulldowns')
          })
      axios.get('/api/filters/all/' + this.extent_id)
          .then(response => {
            this.all_saved_filters_for_extent = response.data
          })
          .catch(error => {
            console.log('oops gettings all filters')
          })
    },
    saved_filter: function() {
      if (this.saved_filter) {
        this.all_filter_tests = []
        if (this.saved_filter && this.saved_filter.asset_filter_tests) {
            this.saved_filter.asset_filter_tests.forEach(t => {
                // For some brain-damaged reason the asset filters attached to saved filters
                // have fields named "field" and "value" but the ad hoc field names are "field_name"
                // and "field_value"
                t.field_value = t.value
                t.field_name = t.field
                this.all_filter_tests.push(t)
            })
        }
      }
      if (this.saved_filter && this.saved_filter.shared) {
        this.shared = true
        this.shared_name = this.saved_filter.name
      } else { this.shared = false}
      this.modified_asterisk = ''
    },
    temp_filter_tests_to_add: function() {
      if (this.temp_filter_tests_to_add) {
        this.temp_filter_tests_to_add.forEach(t => {
          // For some brain-damaged reason the asset filters attached to saved filters
          // have fields named "field" and "value" but the ad hoc field names are "field_name"
          // and "field_value"
          t.field_value = t.value
          t.field_name = t.field
          this.all_filter_tests.push(t)
        })
        this.$emit('updateAllFilterTests', {
          all_filter_tests: this.all_filter_tests,
          changed: true,
        })
      }
    }
  },
  methods: {
    show_operator_panel() {
      this.show_operator_options = true
    },
    set_operator_text(operator) {
      this.operator_text = operator.long
      this.operator_instructions = operator.instructions
    },
    operator_select(operator) {
      this.tentative_filter.operation = operator.short
      this.show_filter_value= operator.requires_value
      this.set_operator_text(operator)
      this.show_operator_options = false
    },
    delete_test() {
      this.all_filter_tests = this.all_filter_tests.filter(f => {
        return ! (
            f.field_value === this.tentative_filter.field_value &&
            f.operation   === this.tentative_filter.operation &&
            f.field_name  === this.tentative_filter.field_name
        )
      });
      this.$emit('updateAllFilterTests', {
        all_filter_tests: this.all_filter_tests,
        changed: true,
      })
      this.show_test_editor = false
      this.modified_asterisk = '*'
    },
    use_now() {
      console.log('(in Filters) tentative_filter: ')
      console.log(this.tentative_filter)
      console.log('(in Filters) all_filter_tests: ')
      console.log(this.all_filter_tests)
      if (this.mode === 'new') {
        this.all_filter_tests.push(this.tentative_filter)
        console.log('(in Filters) all_filter_tests after push: ')
        console.log(this.all_filter_tests)
      }
      this.$emit('updateAllFilterTests', {
        all_filter_tests: this.all_filter_tests,
        changed: true,
      })
      this.show_test_editor = false
      this.modified_asterisk = '*'
    },
    addNewTest() {
      this.mode = 'new'
      this.tentative_filter = {
        field_name: null,
        operation: "=",
        field_value: null,
        long: "",
        instructions: "",
      }
      this.set_operator_text(this.tentative_filter)
      this.show_test_editor = true
    },
    editExistingTest(test) {
      this.mode = 'modify'
      this.tentative_before_values.field_name = test.field_name
      this.tentative_before_values.operation = test.operation
      this.tentative_before_values.field_value = test.field_value

      // Must find the rich information for the operator that matches test.operation
      let operator = this.operators.find(o => {
        return o.short === test.operation
      })

      this.set_operator_text(operator)

      this.tentative_filter = test
      this.show_test_editor = true
    }
  }
}
</script>

<style scoped>

</style>